<template>
    <div class="isv-wrap">
        <input class="isv-input" type="text" :placeholder="placeholderText" v-model="draft" @input="onTyping"
            @blur="onBlur" @keyup.enter="$emit('enter')" />
    </div>
</template>

<script>
export default {
    name: "InputSmartValue",
    props: {
        value: { type: Number, default: 0 },
        mode: { type: String, default: "money" },
        placeholder: { type: String, default: "" }
    },
    data() {
        return {
            draft: ""
        };
    },
    computed: {
        placeholderText() {
            if (this.placeholder) return this.placeholder;
            return this.mode === "percent"
                ? "ex.: 5 ou 5,5 (0–100)"
                : "ex.: 10,50";
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(v) {
                this.draft = this.formatValue(v);
            }
        },
        mode() {
            this.draft = this.formatValue(this.value);
        }
    },
    methods: {
        formatValue(v) {
            if (this.mode === "money") return this.formatBRL(v);
            return v ? String(v).replace(".", ",") : "";
        },
        formatBRL(v) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2
            }).format(v || 0);
        },
        onTyping(e) {
            let val = e.target.value;
            if (this.mode === "percent") {
                val = val.replace(/[^\d,\.]/g, "").replace(",", ".");
                const num = parseFloat(val);
                if (!isNaN(num)) this.$emit("input", num);
                this.draft = val.replace(".", ",");
            } else {
                const digits = val.replace(/\D/g, "");
                const number = parseFloat(digits) / 100;
                if (!isNaN(number)) this.$emit("input", number);
                this.draft = this.formatBRL(number);
            }
        },
        onBlur() {
            const parsed = this.mode === "money" ? this.parseMoney() : this.parsePercent();
            if (!isNaN(parsed)) this.$emit("input", parsed);
            this.draft = this.formatValue(parsed);
        },
        parseMoney() {
            const onlyDigits = this.draft.replace(/\D/g, "");
            if (!onlyDigits) return NaN;
            return Number(onlyDigits) / 100;
        },
        parsePercent() {
            return parseFloat(this.draft.replace(",", "."));
        }
    }
};
</script>

<style scoped>
.isv-wrap {
    width: 100%;
}

.isv-input {
    width: 100%;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 6px 10px;
    font-size: 14px;
    color: #111827;
    outline: none;
}
</style>
